import { useState, useEffect } from 'react';
import type { BannerDeviceType } from '@asetquhub/validation';

/**
 * Hook to detect device type based on User-Agent and screen width
 * @returns 'MOBILE' for mobile devices, 'DESKTOP' for desktop
 */
export function useDeviceType(): BannerDeviceType {
  const [deviceType, setDeviceType] = useState<BannerDeviceType>(() => {
    // Initial detection on mount
    return detectDeviceType();
  });

  useEffect(() => {
    // Update on window resize
    const handleResize = () => {
      setDeviceType(detectDeviceType());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
}

/**
 * Detect device type based on User-Agent and screen width
 */
function detectDeviceType(): BannerDeviceType {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return 'MOBILE'; // Default for SSR
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const screenWidth = window.innerWidth;

  // Check User-Agent for mobile devices
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  // Check screen width (tablet/mobile breakpoint)
  const isMobileWidth = screenWidth < 768;

  // Return MOBILE if either UA or width indicates mobile
  return isMobileUA || isMobileWidth ? 'MOBILE' : 'DESKTOP';
}
